import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import HeaderBar from '../components/helpers/HeaderBar.jsx';
import HeaderLinks from '../components/helpers/HeaderLinks.jsx';
import FlatButton from 'material-ui/FlatButton';
import './NotFound.css';

export default class NotFound extends Component {
  goHome() {
    browserHistory.push('/');
  }

  render () {
    return (
      <div>
        <HeaderBar rightAction={
            <HeaderLinks auth={this.props.auth} />
          } />
        <div className="page-wrapper">
          <p>
            Uh-oh. Something went wrong.
          </p>
          <p>
            Unfortunately, a 404 error occurred. This page couldn't be found.
          </p>
          <p>
            Check back again later or return home by clicking below.
          </p>
          <FlatButton
            label="Back to home"
            className="back-to-generator-button"
            backgroundColor="#30353a"
            hoverColor="#686C6F"
            onClick={this.goHome}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/NotFound.jsx